import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import validateEmail from "../util/validateEmail";

const Login = ({ setLoggedin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loginError, setLoginError] = useState("");
  const [showModal, setShowModal] = useState(true);

  const navigate = useNavigate();

  // Email validation only if user types something
  useEffect(() => {
    if (email.length > 0) {
      setEmailError(validateEmail(email) ? "" : "Invalid credentials");
    } else {
      setEmailError("");
    }
  }, [email]);

  // Password validation only if user types something
  useEffect(() => {
    if (password.length > 0) {
      setPasswordError(
        password.length >= 3
          ? ""
          : "Password must be at least 3 characters long"
      );
    } else {
      setPasswordError("");
    }
  }, [password]);

  function handleLogin() {
    if (email === "9494765396" && password === "9494765396") {
      setLoginError("");
      setLoggedin(true);
      setShowModal(false); // close modal
      navigate("/interview");
    } else {
      setLoginError("Invalid credentials ❌");
    }
  }

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-4 rounded-3 shadow">
              <div className="modal-header border-0">
                <h5 className="modal-title">Login</h5>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                  {emailError && (
                    <div className="text-danger small">{emailError}</div>
                  )}
                </div>
                <div className="mb-3">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                  />
                  {passwordError && (
                    <div className="text-danger small">{passwordError}</div>
                  )}
                </div>
                {loginError && (
                  <div className="text-danger text-center mb-2">{loginError}</div>
                )}
                <button
                  className="btn btn-primary w-100"
                  onClick={handleLogin}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
